import * as FIELD_NAME from 'constant/form-item-names'
import { Form, Upload, Button } from 'antd'
import { PaperClipOutlined, UploadOutlined } from '@ant-design/icons'
import React from 'react'
import PropTypes from 'prop-types'

const UploadFile = ({ fileName, name = FIELD_NAME.IMAGE_META }) => {
  const normFile = (event) => event?.file

  return (
    <>
      <Form.Item
        getValueFromEvent={normFile}
        name={name}
        valuePropName='file'
      >
        <Upload
          beforeUpload={() => false}
          maxCount={1}
          multiple={false}
        >
          <Button icon={<UploadOutlined />}>Upload File</Button>
        </Upload>
      </Form.Item>
      {fileName && <p>Current File: <PaperClipOutlined /> {fileName}</p>}
    </>
  )
}

UploadFile.propTypes = {
  fileName: PropTypes.string,
  name: PropTypes.string
}

export default UploadFile
